import React, { useState } from "react";

import FormInput from "../components/FormInput";
import CollapsibleColumn from "../components/CollapsibleColumn";
import "../styles/UniversalFooter.css";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const UniversalFooter = () => {
  const [email, setEmail] = useState("");

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      alert("Please enter a valid email address.");
      return;
    }

    // API request payload
    const payload = {
      email,
      reason: "newsletter",
      product_id: null,
      size: null,
    };

    try {
      // Make POST request to the API
      const response = await fetch(`${apiUrl}/ct/add/email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-App-Secret": process.env.REACT_APP_APP_SECRET,
        },
        body: JSON.stringify(payload),
      });

      // Check for HTTP errors
      if (!response.ok) {
        const errorData = await response.json();
        // Directly show the message provided by the API (e.g., the duplicate message)
        alert(errorData.message || "Failed to submit email.");
        return;
      }

      // Parse the response JSON
      const responseData = await response.json();

      // Handle success
      alert("Thank you! You have been added to the email list.");
      console.log("API Response:", responseData);

      // Clear the email field and close the popup
      setEmail("");
    } catch (error) {
      // Handle errors
      console.error("Error submitting email:", error);
      alert(`An error occurred: ${error.message}`);
    }
  };

  return (
    <section className="universal-footer">
      <form className="newsletter-form" onSubmit={handleEmailSubmit}>
        <span className="newsletter-heading">Subscribe to our Newsletter</span>
        <span className="newsletter-sub-heading">
          Receive our newsletter and discover our world, collections, and latest
          news from us
        </span>
        <FormInput
          label="Email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          rows={1}
          required
        />
        <span className="newsletter-sub-heading">
          I acknowledge that my email will be processed by Charles Timmins in
          accordance with the provisions of the Privacy Policy
        </span>
        <button type="submit" className="popup-submit">
          Subscribe
        </button>
      </form>
      <CollapsibleColumn
        title="Get in Touch"
        links={[
          { to: "/faqs", label: "FAQs" },
          { to: "/contact", label: "Contact Us" },
        ]}
      />
      <CollapsibleColumn
        title="Legal and Cookies"
        links={[
          { to: "/legal-and-cookies", label: "Terms and Conditions" },
          {
            to: "/legal-and-cookies/privacy-policy",
            label: "Privacy Policy",
          },
        ]}
      />
      <CollapsibleColumn
        title="Follow Us"
        links={[
          {
            to: "https://www.instagram.com/charlestimmins_/?igsh=MW54ZXhheDMxcWV3aw%3D%3D&utm_source=qr#",
            label: "Instagram",
          },
          {
            to: "https://www.tiktok.com/@charlestimminss?_t=ZN-8vFdtS7vlaw&_r=1",
            label: "TikTok",
          },
        ]}
      />
    </section>
  );
};

export default UniversalFooter;
